<template>
  <div class="widget">
    <div class="header">
      <div class="doctor-icon">
        <i class="pi pi-phone" style="font-size: 1rem; color: #fff"></i>
      </div>
    </div>

    <div class="title">Консультация врача</div>
    <div class="subtitle pb-2">Онлайн или очно</div>

    <div class="cta-button mb-0">Записаться</div>
  </div>
</template>
<style scoped>
.widget {
  width: 100%;
  padding: 16px;
  border-radius: 24px;
  cursor: pointer;
  transition: transform 0.2s;
}

.widget:hover {
  transform: scale(1.02);
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.doctor-icon {
  background: #4caf50;
  padding: 8px;
  border-radius: 50%;
  height: 30px;
  width: 30px;
  display: flex;
  align-content: center;
  justify-content: center;
  align-items: center;
  box-shadow: 1px 1px 16px 0px #dddddd;
}

.title {
  color: #2c3d50;
  font-size: 12pt;
  font-weight: 500;
  line-height: 1.1;
  margin-bottom: 8px;
}

.subtitle {
  color: #2c3d50;
  font-size: 10pt;
  margin-bottom: 16px;
}

.cta-button {
  background: #4caf50;
  color: white;
  padding: 8px 10px;
  border-radius: 12px;
  font-size: 10pt;
  font-weight: 500;
  text-align: center;
  margin-bottom: 10px;
}

.available {
  color: #4ade80;
  font-size: 1px;
  margin-bottom: 4px;
}

.next-slot {
  color: #71717a;
  font-size: 12px;
}
</style>
